import 'bootstrap/dist/css/bootstrap.min.css';
import '@/assets/css/image-reveal.css';
import { bootstrapStorefrontThemeFromStorage } from '@/composables/useStorefrontTheme';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import store from './store/index';
import * as bootstrap from 'bootstrap';
import { LOCALE_STORAGE_KEY, resolveLocale, DEFAULT_LOCALE } from '@/composables/useI18n';
import { initStorefrontImageReveal } from '@/utils/storefrontImageReveal';

const toastIcon = (type) => ({
    iconTag: "span",
    iconClass: `godea-toast-icon godea-toast-icon--${type}`
});

const options = {
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    position: "bottom-right",
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false,
    maxToasts: 3,
    transition: "Vue-Toastification__fade",
    newestOnTop: true,
    toastDefaults: {
        success: { icon: toastIcon("success") },
        info: { icon: toastIcon("info") },
        warning: { icon: toastIcon("warning") },
        error: { icon: toastIcon("error") },
        default: { icon: toastIcon("info") }
    },
    filterBeforeCreate: (toast, toasts) => {
        if (toasts.filter(
            t => t.content === toast.content
        ).length !== 0) {
            return false;
        }
        return toast;
    }
};

if (typeof window !== 'undefined' && !window.bootstrap) {
    window.bootstrap = bootstrap;
}

bootstrapStorefrontThemeFromStorage();

const app = createApp(App);
app.use(router);
app.use(store);
app.use(Toast, options);

// Bootstrap i18n locale desde localStorage antes de montar (clave godea_locale,
// default es). Idempotente: el store ya lo restaura en su init; aquí se garantiza.
let storedLocale = DEFAULT_LOCALE;
if (typeof window !== 'undefined') {
  try {
    storedLocale = resolveLocale(window.localStorage.getItem(LOCALE_STORAGE_KEY));
  } catch {
    storedLocale = DEFAULT_LOCALE;
  }
}
store.dispatch('setLocale', storedLocale);

initStorefrontImageReveal(document.getElementById('app'));
app.mount('#app');

// Import geo + visitor tracker early so prices resolve to EUR/USD by country
import { loadDisplayCurrency } from '@/composables/useDisplayCurrency';
import '@/utils/visitorTracker';

loadDisplayCurrency();
